import { MaterialDTO, PreSignedUrlDTO } from "@onetutor/shared/dto";
import { onetutor } from "./onetutor";

const material = onetutor.injectEndpoints({
  endpoints: (builder) => ({
    postMaterial: builder.mutation<string, { courseId: string; file: File }>({
      query: ({ courseId, file }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: `course/${courseId}/material`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: (_result, _error, { courseId }) => [
        "material",
        { type: "course", id: courseId },
      ],
    }),
    getMaterials: builder.query<MaterialDTO[], string>({
      query: (courseId) => `course/${courseId}/material`,
      providesTags: ["material"],
    }),
    getMaterial: builder.query<
      PreSignedUrlDTO,
      { courseId: string; materialFilename: string }
    >({
      query: ({ courseId, materialFilename }) =>
        `course/${courseId}/material/${encodeURIComponent(materialFilename)}`,
    }),
    deleteMaterial: builder.mutation<
      void,
      { courseId: string; materialFilename: string }
    >({
      query: ({ courseId, materialFilename }) => ({
        url: `course/${courseId}/material/${materialFilename}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, { courseId }) => [
        "material",
        { type: "course", id: courseId },
      ],
    }),
    regenerateEmbedding: builder.mutation<
      void,
      { courseId: string; materialFilename: string }
    >({
      query: ({ courseId, materialFilename }) => ({
        url: `course/${courseId}/material/${materialFilename}/regenerate`,
        method: "POST",
      }),
      invalidatesTags: ["material"],
    }),
    regenerateAllEmbeddings: builder.mutation<void, string>({
      query: (courseId) => ({
        url: `course/${courseId}/material/regenerate`,
        method: "POST",
      }),
    }),

    updateMaterialStatus: builder.mutation<
      void,
      { courseId: string; materialFilename: string; enabled: boolean }
    >({
      query: ({ courseId, materialFilename, enabled }) => ({
        url: `course/${courseId}/material/${materialFilename}/status`,
        method: "POST",
        body: {
          name: materialFilename,
          isActive: enabled,
          embeddingCreated: null,
        } as MaterialDTO,
      }),
      invalidatesTags: ["material"],
    }),
    getDocumentImage: builder.query<
      PreSignedUrlDTO,
      { documentId: string; courseId: string }
    >({
      query: ({ courseId, documentId }) => ({
        url: `course/${courseId}/material/document/${documentId}`,
        method: "GET",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  usePostMaterialMutation,
  useGetMaterialsQuery,
  useLazyGetMaterialQuery,
  useDeleteMaterialMutation,
  useRegenerateEmbeddingMutation,
  useRegenerateAllEmbeddingsMutation,
  useGetDocumentImageQuery,
  useUpdateMaterialStatusMutation,
} = material;
